// ======================================================================
// File Name       : EmailDetailDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Item } from '../Detail';
import ModalWrapper from '../modal/ModalWrapper';
import { mailSendStatusType, MAIL_SEND_STATUS, EMAIL_SENDING_STATUS_NOTE } from '../../constants/EmailConstants';

class EmailDetailDialog extends React.Component {
  constructor(props) {
    super();
    this.getModalOptions = this.getModalOptions.bind(this);
  }

  getModalOptions() {
    return {
      title: 'メール詳細',
      footerBtns: [{
        name: '閉じる',
        onClick: this.props.hideModal,
        variant: 'primary',
      }],
    };
  }

  render() {
    const { emailInfo } = this.props;
    const getTransmissionResult = () => {
      const statusValue = parseInt(emailInfo.emailSendStatus, 10);
      const emailSendResult = emailInfo.emailSendResult;
      if (emailInfo.emailSendResult) {
        return mailSendStatusType[statusValue].name.concat('\n').concat(emailSendResult);
      }
      return mailSendStatusType[statusValue].name;
    };

    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <Form className='form-horizontal'>
          <Item name="件名" value={emailInfo.emailTitle} />
          <Item name="ユーザー名" value={emailInfo.receiverUserName} />
          <Item name="ユーザーグループ名" value={emailInfo.receiverUserGroupNames} />
          <Item name="送信日" value={emailInfo.emailSendDate} />
          <Item name="返信時の宛先" value={emailInfo.emailReplyTo} />
          <Item name="送信結果" value={getTransmissionResult()} />
          <Item name="本文" value={emailInfo.emailContents} />
          {
            emailInfo.emailSendStatus === MAIL_SEND_STATUS.WAITING && (
              <div className="form-info form-group required">{EMAIL_SENDING_STATUS_NOTE}</div>
            )
          }
        </Form>
      </ModalWrapper>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const { emailInfo } = state.email;
  return {
    emailInfo,
  };
};

export default connect(mapStateToProps)(EmailDetailDialog);
